import { Checkbox } from 'antd';
import React from 'react';
import { SCHEDULE_DAYS, ScheduleDay } from './days';

type Props = {
  /** Which days are working days. */
  days: Partial<Record<ScheduleDay, boolean>>;
  /** Omit (or set disabled) for a read-only schedule. */
  onChange?: (day: ScheduleDay, checked: boolean) => void;
  disabled?: boolean;
};

/**
 * NX-4948: the Mon–Sun "Schedule per week" table of a working pattern, as in
 * the Old UI — editable on the company pattern form, read-only on the
 * employee.
 */
const AppWorkingPatternSchedule: React.FC<Props> = ({
  days,
  onChange,
  disabled = !onChange,
}) => (
  <div className="overflow-x-auto">
    <table className="w-full border border-neutral-200 text-center">
      <thead>
        <tr className="bg-neutral-50">
          {SCHEDULE_DAYS.map((day) => (
            <th
              key={day}
              className="capitalize font-medium text-neutral-500 py-3 px-2 border border-neutral-200"
            >
              {day}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {SCHEDULE_DAYS.map((day) => (
            <td key={day} className="py-3 px-2 border border-neutral-200">
              <Checkbox
                aria-label={day}
                checked={!!days[day]}
                disabled={disabled}
                onChange={(e) => onChange?.(day, e.target.checked)}
              />
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  </div>
);

export default AppWorkingPatternSchedule;
